<template>
  <div id="board">
    <img src="@/assets/start-bg.png" class="board-bg" />
    <!-- 导航栏 -->
    <van-nav-bar
      title="留言板"
      fixed
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="record">
      <!-- <div class="record-form">
        <div class="form-tit" @click="toStep(1)">
          <div class="form-tit1">
            <span>1</span>
            <div>填信息</div>
            <img src="@/assets/board1.png" />
          </div>
        </div>
        <div
          class="form-tit"
          :class="[stepStatus ? 'form-tit2' : '']"
          @click="toStep(2)"
        >
          <div class="form-tit1">
            <span>2</span>
            <div>写内容</div>
            <img src="@/assets/board2.png" v-if="stepStatus" />
            <img src="@/assets/board1.png" v-if="!stepStatus" />
          </div>
        </div>
      </div> -->
      <div class="form-main">
        <van-field
          v-model="name"
          label="真实姓名"
          placeholder="请输入您的姓名"
          required
        />
        <van-field
          v-model="phone"
          label="联系电话"
          placeholder="请输入您的手机号"
          required
        />
        <van-field
          v-model="mail"
          label="身份证号"
          placeholder="请输入您的身份证号"
          required
        />
        <!-- <div class="form-btn" @click="toStep(2)">下一步</div> -->
        <van-field
          required
          v-model="message"
          rows="3"
          autosize
          label="正文内容"
          type="textarea"
          maxlength="300"
          placeholder="请输入您要留言的内容"
          show-word-limit
          :border="false"
        />

        <div class="img-up">
          <van-uploader
            v-model="fileList"
            :max-count="4"
            :after-read="afterRead"
            @delete="deleteImg"
          />
          <div class="upLoad-tip">上传照片（选填）</div>
        </div>
        <div class="form-btn" @click="toSubmit()">提交</div>
      </div>
    </div>
    <van-dialog
      v-model="show"
      title="提示"
      message="确定要提交吗？"
      :beforeClose="beforeClose"
      show-cancel-button
    ></van-dialog>
  </div>
</template>
<script>
import { NavBar, Dialog, Field, Toast, Uploader } from "vant";
import { upLoad, messageAdd } from "@/api/apiData";
import { mapState } from "vuex";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Uploader.name]: Uploader,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      name: "", //姓名
      phone: "", //联系电话
      mail: "", //邮箱
      message: "", //内容
      images: "", //图片
      imagesArr: [], //图片
      stepStatus: true,
      fileList: [],
      show: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    // 提交表单
    toSubmit() {
      var that = this;
      var pattern = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57]|19[0-9]|16[0-9])[0-9]{8}$/;
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (this.name == "") {
        Toast("请输入您的姓名");
        return false;
      }
      if (this.phone == "") {
        Toast("请输入您的手机号");
        return false;
      }
      if (!pattern.test(this.phone)) {
        Toast("请输入正确的手机号");
        return false;
      }
      if (this.mail == "") {
        Toast("请输入您的身份证号");
        return false;
      }
      if (reg.test(this.mail) === false) {
        Toast("请输入正确的的身份证号");
        return false;
      }
      if (this.message == "") {
        Toast("请输入您要留言的内容");
        return false;
      }
      this.show = true;
    },
    beforeClose(action, done) {
      this.images = this.imagesArr.toString();
      var parm = {
        name: this.name,
        telphone: this.phone,
        id_card: this.mail,
        content: this.message,
        images: this.images,
      };
      if (action === "confirm") {
        messageAdd(parm).then((res) => {
          if (res.code == 1) {
            done();
            Toast.success("提交成功");
            setTimeout((res) => {
              location.reload();
            }, 1500);
          } else {
            done();
            Toast(res.msg);
          }
        });
      } else {
        done();
      }
    },
    toUrl(url) {
      this.$router.push(url);
    },
    toStep(n) {
      if (n == 1) {
        this.stepStatus = true;
      } else {
        this.stepStatus = false;
      }
    },
    // 上传图片
    afterRead(file) {
      // 大于1MB的jpeg和png图片都缩小像素上传
      if (/\/(?:jpeg|png)/i.test(file.file.type) && file.file.size > 1000000) {
        // let cal = 1024*1024/file.file.size; //计算比例，也可以自己定义比例 0.5等等
        // 创建Canvas对象(画布)
        let canvas = document.createElement("canvas");
        // 获取对应的CanvasRenderingContext2D对象(画笔)
        let context = canvas.getContext("2d");
        // 创建新的图片对象
        let img = new Image();
        // 指定图片的DataURL(图片的base64编码数据)
        img.src = file.content;
        // 监听浏览器加载图片完成，然后进行进行绘制
        img.onload = () => {
          //最大高度
          const maxHeight = 500;
          //最大宽度
          const maxWidth = 500;
          // 指定canvas画布大小，该大小为最后生成图片的大小
          const originHeight = img.height;
          const originWidth = img.width;
          let compressedWidth = img.height;
          let compressedHeight = img.width;
          if (originWidth > maxWidth && originHeight > maxHeight) {
            // 更宽更高，
            if (originHeight / originWidth > maxHeight / maxWidth) {
              // 更加严重的高窄型，确定最大高，压缩宽度
              compressedHeight = maxHeight;
              compressedWidth = maxHeight * (originWidth / originHeight);
            } else {
              //更加严重的矮宽型, 确定最大宽，压缩高度
              compressedWidth = maxWidth;
              compressedHeight = maxWidth * (originHeight / originWidth);
            }
          } else if (originWidth > maxWidth && originHeight <= maxHeight) {
            // 更宽，但比较矮，以maxWidth作为基准
            compressedWidth = maxWidth;
            compressedHeight = maxWidth * (originHeight / originWidth);
          } else if (originWidth <= maxWidth && originHeight > maxHeight) {
            // 比较窄，但很高，取maxHight为基准
            compressedHeight = maxHeight;
            compressedWidth = maxHeight * (originWidth / originHeight);
          } else {
            // 符合宽高限制，不做压缩
          }
          canvas.height = compressedHeight;
          canvas.width = compressedWidth;
          /* drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，400，300是将图片按给定的像素进行缩小。
        如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。*/

          context.drawImage(img, 0, 0, compressedWidth, compressedHeight);
          // 将绘制完成的图片重新转化为base64编码，file.file.type为图片类型，0.92为默认压缩质量
          file.content = canvas.toDataURL(file.file.type, 0.92);
          // 最后将base64编码的图片保存到数组中，留待上传。
          var parm = {
            file: file.content,
          };
          upLoad(parm).then((res) => {
            this.imagesArr.push(res.data.path);
          });
        };
      } else {
        var parm = {
          file: file.content,
        };
        upLoad(parm).then((res) => {
          this.imagesArr.push(res.data.path);
        });
      }
      // var parm = {
      //   file: file.content
      // };
      // // this.imagesArr = [1, 2, 3, 4, 5]
      // uploadImages(parm).then(res => {
      //   this.imagesArr.push(res.data[0]);
      // });
    },
    deleteImg(file, name) {
      var index = name.index;
      this.imagesArr.splice(index, 1);
    },
    // 跳转详情
    toInfo(id) {
      this.$router.push({
        path: "/boardInfo",
        query: {
          id: id,
        },
      });
    },
    onClickLeft(){
        this.$router.push("/contant/index")
    }
  },
};
</script>
<style scoped>
#board {
  padding-top: 46px;
  padding-bottom: 100px;
  /* background: #f7f7f7; */
}
.board-bg {
  position: fixed;
  top: 0;
  z-index: -2;
  left: 0;
  width: 100%;
  bottom: 0;
  height: 100%;
}
.bg-color {
  background: #f7f7f7;
  padding-top: 0.5rem;
}
.items {
  text-align: left;
  background: white;
  padding: 0.3rem 0;
  margin-bottom: 0.5rem;
}
.item-info1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.5rem;
}
.item-info2 {
  padding: 0 0.5rem 0.3rem;
  color: #b2afaf;
  font-size: 12px;
  border-bottom: solid 1px ghostwhite;
}
.item-info3 {
  padding: 0.5rem;
  font-size: 13px;
  display: flex;
  color: #6a6a6a;
  justify-content: space-between;
  position: relative;
  min-height: 5vh;
}
.item-info3-text {
  width: 80%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.item-info3 img {
  width: 9vh;
  height: 9vh;
  position: absolute;
  top: 0;
  right: 0;
}
.item-info4 {
  color: #b2afaf;
  font-size: 12px;
  padding: 0 0.5rem;
}
.item2-info1 {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.item2-tit {
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.item2-status {
  color: #707070;
  font-size: 12px;
  padding: 0.1rem 0.5rem;
  background: #ebebeb;
  text-align: center;
  border: solid 1px;
  height: 1rem;
  /* line-height: 1rem; */
  width: auto;
  border-radius: 0.3rem;
}
.record {
  text-align: left;
  padding: 0.2rem 0.3rem;
}
.record-info {
  background: #fff3f2;
  padding: 0.5rem 0.5rem;
}
.record-tit {
  font-weight: bold;
}
.record-tit span {
  width: 10px;
  height: 10px;
  background: #e23a2d;
  display: inline-block;
  border-radius: 10px;
}
.record-main {
  font-size: 14px;
  margin-top: 10px;
  margin-left: 1rem;
}
.record-main span {
  color: #e23a2d;
}
/* 填写信息 */
.record-form {
  display: flex;
  width: 100%;
}
.form-tit {
  width: 36%;
}
.record-form {
  margin-left: 1rem;
  margin-top: 1rem;
}
.form-tit1 {
  display: flex;
  position: relative;
  color: white;
  /* align-items: center; */
  justify-content: center;
  height: 2rem;
  line-height: 2rem;
  font-size: 14px;
  font-weight: bold;
}
.form-tit1 span {
  width: 1.2rem;
  height: 1.2rem;
  background: white;
  color: #e23a2d;
  font-size: 14px;
  border-radius: 1.5rem;
  line-height: 1.2rem;
  text-align: center;
  font-weight: bold;
  margin-top: 0.4rem;
  margin-right: 0.6rem;
}
.form-tit1 img {
  position: absolute;
  width: 100%;
  z-index: -1;
  height: 100%;
}
.form-tit2 .form-tit1 {
  color: #cecece;
}
.form-tit2 span {
  color: #e9e9e9;
}
/* .form-main {
  padding: 0.8rem;
} */
.form-tips {
  color: #bcbcbc;
  font-size: 12px;
}
.form-btn {
  color: white;
  background: #e23a2d;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 5px;
  width: 90%;
  margin: 0 auto;
  margin-top: 10%;
  font-size: 0.36rem;
}
.img-up {
  margin: 0.5rem 0;
  padding: 0.3rem;
}
.upLoad-tip {
  color: #c2c2c2;
  font-size: 12px;
}
</style>